import { CreateOrder, LoadOrderDetails } from './cart.actions';

export const CartLoadingActions = [CreateOrder, LoadOrderDetails];
